<div>
  <core-annexes-list
    class="d-block"
    [canDownload]="true"
    [canUpload]="false"
    [canDelete]="false"
    [canPreview]="true"
    [canEdit]="false"
    [annexes]="annexes()"
  ></core-annexes-list>
</div>
